export { default as vitallLogo } from './vitall-logo.svg';
